import type { GetAdminOrdersParams } from "@/lib/api/generated/model";

/**
 * The reading of the order list the user chose: what is still on its way, what
 * has arrived, or everything.
 *
 * Unlike a workflow status these are fixed by the order itself (a delivery is
 * confirmed or it is not), so they hold for every client whatever phases its
 * workflow has. The phases are offered separately, from the workflow.
 */
export const ORDER_VIEWS = ["open", "delivered", "all"] as const;

export type OrderView = (typeof ORDER_VIEWS)[number];

export const ORDER_VIEW_LABELS: Readonly<Record<OrderView, string>> = {
  open: "Onderweg",
  delivered: "Geleverd",
  all: "Alle",
};

export function isOrderView(value: unknown): value is OrderView {
  return ORDER_VIEWS.some((view) => view === value);
}

/**
 * The query parameters one view stands for.
 *
 * "Onderweg" is every order whose delivery was not confirmed yet, so an order
 * stays on it however far its phases have come. A delivered order is shown the
 * latest first, because the question on that view is what arrived recently.
 */
export function toOrderViewQuery(view: OrderView): GetAdminOrdersParams {
  switch (view) {
    case "open":
      return { "exists[deliveredAt]": false };
    case "delivered":
      return { "exists[deliveredAt]": true, "order[deliveredAt]": "desc" };
    case "all":
      return {};
  }
}
